package link.erpango.quip

import link.erpango.quip.utils.DatetimeUtils
import link.erpango.quip.utils.getPlatform

class Greeting {
    private val platform = getPlatform()

    fun greet(): String {
        val currentTime = DatetimeUtils.getCurrentTimeUTC()
        return "Hello, ${platform.name}! A las ${currentTime}"
    }
}